// extracted by mini-css-extract-plugin
export default {"yaowen_center_box":"index_yaowen_center_box_WZYJV"};